import React from 'react';
import { ClipboardCheck, Shield, BookCheck, Code, Users, CheckCircle } from 'lucide-react';
import Image1 from '../images/1.png';
import Image2 from '../images/2.png';
import Image3 from '../images/3.png';
import Image4 from '../images/4.png';
import Image5 from '../images/5.png';
import Image6 from '../images/6.png';


const features = [
    {
        icon: Image1,
        bgColor: "bg-primary-subtle",
        heading: "Advanced Access Control",
        subheading: "Only authorized participants influence the ecosystem.",
    },
    {
        icon: Image2,
        bgColor: "bg-primary-subtle",
        heading: "Trust & Confidence",
        subheading: "Trust secured through blockchain-driven accountability."
    },
    {
        icon: Image3,
        bgColor: "bg-primary-subtle",
        heading: "Decentralized Authority",
        subheading: "Power distributed across the community, not concentrated."
    },
    {
        icon: Image4,
        bgColor: "bg-primary-subtle",
        heading: "Clear Governance",
        subheading: "Every vote counts, every decision is crystal clear."
    },
    {
        icon: Image5,
        bgColor: "bg-primary-subtle",
        heading: "Secure Voting Mechanics",
        subheading: "Preserving the integrity of every democratic choice."
    },
    {
        icon: Image6,
        bgColor: "bg-primary-subtle",
        heading: "Immutable Records",
        subheading: "A record-keeping system immune to tampering."
    }
];

export default function FeaturesSection() {
    return (
        <div className="text-white py-5">
            <div className="container py-5">
                <div className="row text-center mb-5">
                    <div className="col-lg-12 mx-auto">
                        <h3 className="display-5 mb-4 hero-title text-primary">Shared Decisions. Shared Success.</h3>
                        <p className="lead">
                            Turning collective vision into unstoppable progress.
                        </p>
                    </div>
                </div>

                <div className="row g-4">
                    {features.map((feature, index) => (
                        <div key={index} className="col-md-4 mb-4">
                            <div className="text-center">
                                <div className={`feature-icon ${feature.bgColor} mx-auto`}>
                                    <img src={feature.icon} height="50px" alt='icon' />
                                </div>
                                <h5 className='mt-3 text-primary'>{feature.heading}</h5>
                                <p className="mb-3">{feature.subheading}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
